import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../api/auth';
import { useAuthStore } from '../store/authStore';

function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  
  const loginMutation = useMutation({
    mutationFn: authApi.login,
    onSuccess: (data) => {
      login(data.user, data.token);
      navigate('/dashboard');
    },
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    loginMutation.mutate(formData);
  };
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-obn-blue to-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-xs w-full">
        <img
          src="/off-by-none-logo.svg"
          alt="Off-by-none"
          className="w-full h-auto mb-8"
        />
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="appearance-none rounded-none relative block w-full px-3 py-2 bg-white/10 backdrop-blur-sm border border-white/20 placeholder-white/50 text-white rounded-t-md focus:outline-none focus:ring-1 focus:ring-white/40 focus:border-white/40 focus:bg-white/15 focus:z-10 sm:text-sm transition-colors"
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={formData.password}
                onChange={handleChange}
                className="appearance-none rounded-none relative block w-full px-3 py-2 bg-white/10 backdrop-blur-sm border border-white/20 placeholder-white/50 text-white rounded-b-md focus:outline-none focus:ring-1 focus:ring-white/40 focus:border-white/40 focus:bg-white/15 focus:z-10 sm:text-sm transition-colors"
                placeholder="Password"
              />
            </div>
          </div>
          
          {loginMutation.error && (
            <div className="rounded-md bg-red-500/20 border border-red-400/30 p-4">
              <div className="text-sm text-red-100">
                {loginMutation.error.response?.data?.error || 'Login failed'}
              </div>
            </div>
          )}
          
          <div>
            <button
              type="submit"
              disabled={loginMutation.isPending}
              className="group relative w-1/2 mx-auto flex justify-center py-2 px-4 border border-transparent text-sm font-semibold rounded-md text-white bg-obn-red hover:bg-obn-red/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent focus:ring-obn-red/60 disabled:opacity-50 transition-colors"
            >
              {loginMutation.isPending ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;